import React, { useState,  useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { translateQuestion, uploadAudioAndTranslate} from './api/TalksApiService'
import axios from 'axios'
import RecordRTC from 'recordrtc'

function QAComponent() {
  // 付費題目（固定前兩題）
  const paidQuestions = [
    '私藏景點清單',
    '私藏美食清單'
  ]

  // 一般題目（隨機抽、不重複）
  const normalQuestions = [
    '你家鄉最常在什麼節日團聚？那天你們會做什麼？',
    '你們那裡約會的時候，通常去哪裡？',
    '你有沒有哪趟旅程是「一個人」去的？那次怎麼樣？',
    '你有沒有去過哪個地方，去了之後完全改變你對生活的看法？',
    '最近有什麼東西讓你上癮？',
    '你有沒有一個不實用但超喜歡的東西？',
    '你有沒有一種「別人覺得怪，但你很愛」的食物搭配？',
    '寫一張明信片給對方',
    '你聽什麼音樂？',
    '如果你是電影主角，你的角色職業會是什麼？',
    '如果你開一家「只賣沒用的東西」的店，你會賣什麼？',
    '如果你中了一億，你第一件會做的事是什麼？',
    '你身邊哪個朋友最怪？他做過什麼事？',
    '你工作上最瘋狂或最好笑的一次經歷是什麼？',
    '如果要讓5歲小孩也聽懂你的工作內容，你會怎麼解釋？',
    '你在工作上最有成就感的是哪一次？你有曾想辭職的瞬間嗎？',
    '如果不做現在的工作，你最想試試哪種工作？為什麼？',
    '有沒有什麼事是你一直夢想去做而沒有去做的？',
    '你有沒有一個荒謬但堅持的迷信？',
    '你是怎麼踏進現在這份工作的？這是你計畫好的嗎？'
  ]

  const [question, setQuestion] = useState('')
  const [remaining, setRemaining] = useState([...normalQuestions])
  const [currentIndex, setCurrentIndex] = useState(0)

  const [showModal, setShowModal] = useState(false)
  const [selectedLangs, setSelectedLangs] = useState([])
  const [translatedResults, setTranslatedResults] = useState({})
  const langMap = {
    ja: 'Japanese',
    fr: 'French',
    es: 'Spanish',
    de: 'German',
    en: 'English',
  }

  // 錄音完成後的音訊連結
  const [audioURL, setAudioURL] = useState(null)
  // 判斷目前是否正在錄音
  const [isRecording, setIsRecording] = useState(false)


  // 使用者選擇的目標翻譯語言（語音翻譯）
  const [targetLang, setTargetLang] = useState(null)
  // 後端回傳的翻譯後音訊檔 URL
  const [translatedAudioURL, setTranslatedAudioURL] = useState(null)

  const [showVoiceLangModal, setShowVoiceLangModal] = useState(false)
  const [recorder, setRecorder] = useState(null)

  useEffect(() => {
    // 讓語音引擎載入語言列表（重要！）
    speechSynthesis.onvoiceschanged = () => {
      console.log('語音引擎載入完成')
    }
  
    // 暖機語音（避免首次播放失敗）
    const dummy = new SpeechSynthesisUtterance('')
    speechSynthesis.speak(dummy)
  }, [])

  // 下一題
  const getQuestion = async () => {
    let nextQ = ''
  
    // 前兩題是付費題：依序顯示
    if (currentIndex < paidQuestions.length) {
      nextQ = paidQuestions[currentIndex]
      setCurrentIndex(prev => prev + 1)
    } else {
      // 一般題目已抽完：顯示提示並清除翻譯
      if (remaining.length === 0) {
        setQuestion('🎉 已經沒有新問題了！請按重新開始')
        setTranslatedResults({})
        return
      }
  
      // 從剩下的題目中隨機抽一題
      const randomIndex = Math.floor(Math.random() * remaining.length)
      nextQ = remaining[randomIndex]
  
      // 把抽中的題目從剩下的題目中移除
      const newRemaining = [...remaining]
      newRemaining.splice(randomIndex, 1)
      setRemaining(newRemaining)
  
      // 累加 index
      setCurrentIndex(prev => prev + 1)
    }
  
    // 顯示問題
    setQuestion(nextQ)
  
    // ✅ 若有選擇語言，自動翻譯並顯示翻譯結果
    if (selectedLangs.length > 0) {
      try {
        const res = await translateQuestion(nextQ, selectedLangs) // 呼叫翻譯 API
        setTranslatedResults(res) // 顯示翻譯結果
      } catch (err) {
        console.error('翻譯失敗', err)
        setTranslatedResults({}) // 失敗時清空翻譯
      }
    } else {
      // 沒選語言則清空翻譯
      setTranslatedResults({})
    }
  }

  // 重新開始
  const reset = () => {
    setRemaining([...normalQuestions])
    setQuestion('')
    setCurrentIndex(0)
    setTranslatedResults({})
  }

  //語音翻譯ask
  const speakText = (text, langCode) => {
    const voices = speechSynthesis.getVoices()
    const matched = voices.find((v) => v.lang === langCode)
  
    const utterance = new SpeechSynthesisUtterance(text)
    utterance.lang = langCode
    if (matched) utterance.voice = matched
  
    utterance.onerror = (e) => {
      console.error('語音播放失敗', e)
      alert('⚠️ 無法播放語音，請嘗試使用電腦或更換語言')
    }
  
    speechSynthesis.speak(utterance)
  }

  // answer錄音
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
  
      const newRecorder = new RecordRTC(stream, {
        type: 'audio',
        mimeType: 'audio/webm', // 如果你想改成 'audio/wav' 也可以
      })
  
      newRecorder.startRecording()
      setRecorder(newRecorder)
      setIsRecording(true)
    } catch (err) {
      console.error('錄音啟動失敗', err)
      alert('請允許使用麥克風，建議使用 Safari 或 Chrome 瀏覽器')
    }
  }

  // 停止錄音
  const stopRecording = async () => {
    if (!recorder) return
  
    recorder.stopRecording(() => {
      const blob = recorder.getBlob()
      const url = URL.createObjectURL(blob)
      setAudioURL(url)
      setIsRecording(false)
    })
  }

  // 播放錄音
  const playAudio = () => {
    if (audioURL) {
      const audio = new Audio(audioURL) // 建立 Audio 播放器
      audio.play() // 播放錄音
    }
  }

  // 將音訊上傳給後端翻譯並播放回傳音檔
  const uploadAndTranslateAudio = async () => {
    // 如果尚未選過語言，先叫使用者選
    if (!targetLang) {
      setShowVoiceLangModal(true)
      return
    }

    if (!audioURL || !targetLang) return

    const res = await fetch(audioURL)
    const blob = await res.blob()
    const file = new File([blob], 'recording.webm', { type: 'audio/webm' })

    try {
      const { audioBase64 } = await uploadAudioAndTranslate(file, targetLang)

      if (audioBase64) {
        new Audio(audioBase64).play()
      } else {
        alert('❌ 沒有回傳語音')
      }
    } catch (err) {
      console.error('翻譯音檔失敗', err)
    }
  }

  return (
    <div className="container text-center mt-5">
      <h1 className="mb-1 display-5">🌟 Icebreaker Question Generator</h1>

      <div className="row justify-content-center">
        {/* Ask 區塊 */}
        <div className="col-md-6 mb-3">
          <button
            className="w-100 btn btn-lg btn-secondary text-white fs-2"
            style={{
              borderRadius: '1rem 1rem 0 0',
              border: 'none'
            }}
          >
            Ask
          </button>

          <div
            className="border p-4 bg-light"
            style={{
              borderRadius: '0 0 1rem 1rem',
              borderTop: 'none'
            }}
          >
            <p className="mt-4 fs-4">
              {question || 'Let’s get started!'}

              {/* 🔽 顯示翻譯結果 */}
                {Object.entries(translatedResults).length > 0 && (
                  <div className="mt-3 text-center">
                    {Object.entries(translatedResults).map(([lang, data]) => (
                      <div key={lang} className="mb-3">
                        <span className="ms-2">{data.text}</span>
                        <button
                          className="btn btn-sm ms-2"
                          onClick={() => {
                            if (data.audioBase64) {
                              const audio = new Audio(data.audioBase64)
                              audio.play()
                            } else {
                              alert('❌ 沒有音訊可以播放')
                            }
                          }}
                        >
                          <i className="bi bi-volume-up-fill fs-4"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                )}

              {/* 顯示付費提示 */}
              {paidQuestions.includes(question) && (
                <p className="mt-4 fs-4">
                    <span className="text-danger fw-bold">🔒 （Would you like to purchase from them?）</span>
                </p>
              )}
            </p>

            <div className="d-flex justify-content-center align-items-center gap-2 mt-3 flex-wrap">
              <button className="btn bg-purple text-white fw-bold fs-5" onClick={getQuestion}>Next Question</button>
              <button className="btn btn-secondary fw-bold fs-5" onClick={reset}>Restart</button>
              <button className="btn btn-outline-secondary ms-2 fw-bold fs-5"  
              onClick={() => {
                setShowModal(true)
              }}>
                Translate
              </button>
            </div>
          </div>

       </div>

      {/* 翻譯語言選擇 Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>選擇要翻譯的語言（最多兩種）</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Object.entries(langMap).map(([code, name]) => (
            <div key={code} className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id={code}
                value={code}
                checked={selectedLangs.includes(code)}
                disabled={!selectedLangs.includes(code) && selectedLangs.length >= 2}
                onChange={(e) => {
                  const checked = e.target.checked
                  const value = e.target.value
                  setSelectedLangs((prev) =>
                    checked ? [...prev, value] : prev.filter((l) => l !== value)
                  )
                }}
              />
              <label className="form-check-label" htmlFor={code}>
                {name}
              </label>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            取消
          </Button>
          <Button variant="primary" onClick={async () => {
            setShowModal(false)
            try {
              const res = await translateQuestion(question, selectedLangs)
              console.log(res)
              setTranslatedResults(res) // 後端要回傳 { fr: '翻譯內容', ja: '...' }
            } catch (err) {
              console.error('翻譯失敗', err)
            }
          }}>
            確定翻譯
          </Button>
        </Modal.Footer>
      </Modal>

        {/* Answer 區塊（保留未來擴充） */}
        <div className="col-md-6">
          <button className="w-100 btn btn-secondary btn-lg fs-2"             
            style={{
                borderRadius: '1rem 1rem 0 0',
                border: 'none'
                }}>
            Answer
          </button>

          <div className="border rounded p-4 text-muted bg-light"             
            style={{
                borderRadius: '0 0 1rem 1rem',
                borderTop: 'none'
          }}>

            <div className="mt-3">
            <div className="d-flex justify-content-center align-items-center gap-2 mt-3 flex-wrap">
              <button
                className="btn bg-purple text-white fs-5 fw-bold"
                onClick={isRecording ? stopRecording : startRecording}
              >
                {isRecording ? (
                  <>
                    Stop Recording <i className="bi bi-stop-fill ms-2"></i>
                  </>
                ) : (
                  <>
                    Record <i className="bi bi-mic-fill ms-2"></i>
                  </>
                )}
              </button>

              <button
                className="btn btn-secondary fs-5 fw-bold"
                disabled={!audioURL}
                onClick={() => {
                  uploadAndTranslateAudio()
                  const text = translatedResults[targetLang]
                  if (text && langMap[targetLang]) {
                    speakText(text, langMap[targetLang])
                  }
                }}
              >
                  Play Translation
              </button>

              <button
                className="btn btn-outline-secondary fs-5 fw-bold"
                onClick={() => setShowVoiceLangModal(true)}
              >
                Switch Language
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showVoiceLangModal} onHide={() => setShowVoiceLangModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>選擇要翻譯成的語言</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {[
      { code: 'ja', name: '日文' },
      { code: 'fr', name: '法文' },
      { code: 'es', name: '西班牙文' },
      { code: 'de', name: '德文' },
      { code: 'en', name: '英文' }
    ].map(({ code, name }) => (
      <div key={code} className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="voiceLang"
          id={`voice-${code}`}
          value={code}
          checked={targetLang === code}
          onChange={() => setTargetLang(code)}
        />
        <label className="form-check-label" htmlFor={`voice-${code}`}>
          {name}
        </label>
      </div>
    ))}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowVoiceLangModal(false)}>
      取消
    </Button>
    <Button
      variant="primary"
      onClick={async () => {
        setShowVoiceLangModal(false)
        // 若使用者是從「翻譯按鈕」跳出 modal，就立刻幫他執行一次翻譯
        if (audioURL && !translatedAudioURL) {
          await uploadAndTranslateAudio()
        }
      }}
    >
      確定
    </Button>
  </Modal.Footer>
</Modal>
      
    </div>

    
  )
}

export default QAComponent